import methods from '../methods'

const API_URL = '/api/admin'

const getRatings = (params?: string | null) => methods.GET_API(`${API_URL}/courses/ratings?${params}`)

export default {
  getRatings
}
